/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as PortalRouteImport } from './routes/portal';
import { Route as OsRouteImport } from './routes/os';
import { Route as EricRouteImport } from './routes/eric';
import { Route as BillingRouteImport } from './routes/billing';
import { Route as IndexRouteImport } from './routes/index';
import { Route as PortalIndexRouteImport } from './routes/portal/index';
import { Route as OsIndexRouteImport } from './routes/os.index';
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index';
import { Route as EricIndexRouteImport } from './routes/eric.index';
import { Route as PortalWelcomeRouteImport } from './routes/portal/welcome';
import { Route as PortalSettingsRouteImport } from './routes/portal/settings';
import { Route as PortalPlaybookRouteImport } from './routes/portal/playbook';
import { Route as PortalNotificationsRouteImport } from './routes/portal/notifications';
import { Route as PortalHelpRouteImport } from './routes/portal/help';
import { Route as PortalContextRouteImport } from './routes/portal/context';
import { Route as PortalBookingRouteImport } from './routes/portal/booking';
import { Route as OnboardingTokenRouteImport } from './routes/onboarding/$token';
import { Route as EricWaitlistRouteImport } from './routes/eric.waitlist';
import { Route as EricReportsRouteImport } from './routes/eric.reports';
import { Route as EricOsRouteImport } from './routes/eric.os';
import { Route as EricOnboardingRouteImport } from './routes/eric.onboarding';
import { Route as EricNotificationsRouteImport } from './routes/eric.notifications';
import { Route as EricInputRequestsRouteImport } from './routes/eric.input-requests';
import { Route as EricContentRouteImport } from './routes/eric.content';
import { Route as EricContactRouteImport } from './routes/eric.contact';
import { Route as EricClientsRouteImport } from './routes/eric.clients';
import { Route as EricCapacityRouteImport } from './routes/eric.capacity';
import { Route as EricAwaitingRouteImport } from './routes/eric.awaiting';
import { Route as EricAgentTelemetryRouteImport } from './routes/eric.agent-telemetry';
import { Route as EricActiveRouteImport } from './routes/eric.active';
import { Route as DIdRouteImport } from './routes/d/$id';
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success';
import { Route as CheckoutCancelRouteImport } from './routes/checkout/cancel';
import { Route as AuthSignOutRouteImport } from './routes/auth/sign-out';
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in';
import { Route as AuthCallbackRouteImport } from './routes/auth/callback';
import { Route as PortalReportsIndexRouteImport } from './routes/portal/reports/index';
import { Route as PortalTasksNewRouteImport } from './routes/portal/tasks/new';
import { Route as PortalTasksTaskIdRouteImport } from './routes/portal/tasks/$taskId';
import { Route as OnboardingTokenSubmittedRouteImport } from './routes/onboarding/$token.submitted';
import { Route as EricTasksTaskIdRouteImport } from './routes/eric.tasks.$taskId';
import { Route as EricReportsReportIdRouteImport } from './routes/eric.reports.$reportId';
import { Route as EricTasksTaskIdStageRouteImport } from './routes/eric.tasks.$taskId.stage';

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any);
const OsRoute = OsRouteImport.update({
  id: '/os',
  path: '/os',
  getParentRoute: () => rootRouteImport,
} as any);
const EricRoute = EricRouteImport.update({
  id: '/eric',
  path: '/eric',
  getParentRoute: () => rootRouteImport,
} as any);
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any);
const OsIndexRoute = OsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OsRoute,
} as any);
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any);
const EricIndexRoute = EricIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.index.lazy').then((d) => d.Route));
const PortalWelcomeRoute = PortalWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => PortalRoute,
} as any);
const PortalSettingsRoute = PortalSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PortalRoute,
} as any);
const PortalPlaybookRoute = PortalPlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => PortalRoute,
} as any);
const PortalNotificationsRoute = PortalNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => PortalRoute,
} as any);
const PortalHelpRoute = PortalHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => PortalRoute,
} as any);
const PortalContextRoute = PortalContextRouteImport.update({
  id: '/context',
  path: '/context',
  getParentRoute: () => PortalRoute,
} as any);
const PortalBookingRoute = PortalBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => PortalRoute,
} as any);
const OnboardingTokenRoute = OnboardingTokenRouteImport.update({
  id: '/onboarding/$token',
  path: '/onboarding/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const EricWaitlistRoute = EricWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.waitlist.lazy').then((d) => d.Route),
);
const EricReportsRoute = EricReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.reports.lazy').then((d) => d.Route));
const EricOsRoute = EricOsRouteImport.update({
  id: '/os',
  path: '/os',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.os.lazy').then((d) => d.Route));
const EricOnboardingRoute = EricOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.onboarding.lazy').then((d) => d.Route),
);
const EricNotificationsRoute = EricNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.notifications.lazy').then((d) => d.Route),
);
const EricInputRequestsRoute = EricInputRequestsRouteImport.update({
  id: '/input-requests',
  path: '/input-requests',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.input-requests.lazy').then((d) => d.Route),
);
const EricContentRoute = EricContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.content.lazy').then((d) => d.Route));
const EricContactRoute = EricContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.contact.lazy').then((d) => d.Route));
const EricClientsRoute = EricClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.clients.lazy').then((d) => d.Route));
const EricCapacityRoute = EricCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.capacity.lazy').then((d) => d.Route),
);
const EricAwaitingRoute = EricAwaitingRouteImport.update({
  id: '/awaiting',
  path: '/awaiting',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.awaiting.lazy').then((d) => d.Route),
);
const EricAgentTelemetryRoute = EricAgentTelemetryRouteImport.update({
  id: '/agent-telemetry',
  path: '/agent-telemetry',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.agent-telemetry.lazy').then((d) => d.Route),
);
const EricActiveRoute = EricActiveRouteImport.update({
  id: '/active',
  path: '/active',
  getParentRoute: () => EricRoute,
} as any).lazy(() => import('./routes/eric.active.lazy').then((d) => d.Route));
const DIdRoute = DIdRouteImport.update({
  id: '/d/$id',
  path: '/d/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout/cancel',
  path: '/checkout/cancel',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthSignOutRoute = AuthSignOutRouteImport.update({
  id: '/auth/sign-out',
  path: '/auth/sign-out',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalReportsIndexRoute = PortalReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => PortalRoute,
} as any);
const PortalTasksNewRoute = PortalTasksNewRouteImport.update({
  id: '/tasks/new',
  path: '/tasks/new',
  getParentRoute: () => PortalRoute,
} as any);
const PortalTasksTaskIdRoute = PortalTasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => PortalRoute,
} as any);
const OnboardingTokenSubmittedRoute =
  OnboardingTokenSubmittedRouteImport.update({
    id: '/submitted',
    path: '/submitted',
    getParentRoute: () => OnboardingTokenRoute,
  } as any);
const EricTasksTaskIdRoute = EricTasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => EricRoute,
} as any).lazy(() =>
  import('./routes/eric.tasks.$taskId.lazy').then((d) => d.Route),
);
const EricReportsReportIdRoute = EricReportsReportIdRouteImport.update({
  id: '/$reportId',
  path: '/$reportId',
  getParentRoute: () => EricReportsRoute,
} as any).lazy(() =>
  import('./routes/eric.reports.$reportId.lazy').then((d) => d.Route),
);
const EricTasksTaskIdStageRoute = EricTasksTaskIdStageRouteImport.update({
  id: '/stage',
  path: '/stage',
  getParentRoute: () => EricTasksTaskIdRoute,
} as any).lazy(() =>
  import('./routes/eric.tasks.$taskId.stage.lazy').then((d) => d.Route),
);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/billing': typeof BillingRoute;
  '/eric': typeof EricRouteWithChildren;
  '/os': typeof OsRouteWithChildren;
  '/portal': typeof PortalRouteWithChildren;
  '/auth/callback': typeof AuthCallbackRoute;
  '/auth/sign-in': typeof AuthSignInRoute;
  '/auth/sign-out': typeof AuthSignOutRoute;
  '/checkout/cancel': typeof CheckoutCancelRoute;
  '/checkout/success': typeof CheckoutSuccessRoute;
  '/d/$id': typeof DIdRoute;
  '/eric/active': typeof EricActiveRoute;
  '/eric/agent-telemetry': typeof EricAgentTelemetryRoute;
  '/eric/awaiting': typeof EricAwaitingRoute;
  '/eric/capacity': typeof EricCapacityRoute;
  '/eric/clients': typeof EricClientsRoute;
  '/eric/contact': typeof EricContactRoute;
  '/eric/content': typeof EricContentRoute;
  '/eric/input-requests': typeof EricInputRequestsRoute;
  '/eric/notifications': typeof EricNotificationsRoute;
  '/eric/onboarding': typeof EricOnboardingRoute;
  '/eric/os': typeof EricOsRoute;
  '/eric/reports': typeof EricReportsRouteWithChildren;
  '/eric/waitlist': typeof EricWaitlistRoute;
  '/onboarding/$token': typeof OnboardingTokenRouteWithChildren;
  '/portal/booking': typeof PortalBookingRoute;
  '/portal/context': typeof PortalContextRoute;
  '/portal/help': typeof PortalHelpRoute;
  '/portal/notifications': typeof PortalNotificationsRoute;
  '/portal/playbook': typeof PortalPlaybookRoute;
  '/portal/settings': typeof PortalSettingsRoute;
  '/portal/welcome': typeof PortalWelcomeRoute;
  '/eric/': typeof EricIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/os/': typeof OsIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/eric/reports/$reportId': typeof EricReportsReportIdRoute;
  '/eric/tasks/$taskId': typeof EricTasksTaskIdRouteWithChildren;
  '/onboarding/$token/submitted': typeof OnboardingTokenSubmittedRoute;
  '/portal/tasks/$taskId': typeof PortalTasksTaskIdRoute;
  '/portal/tasks/new': typeof PortalTasksNewRoute;
  '/portal/reports/': typeof PortalReportsIndexRoute;
  '/eric/tasks/$taskId/stage': typeof EricTasksTaskIdStageRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/billing': typeof BillingRoute;
  '/auth/callback': typeof AuthCallbackRoute;
  '/auth/sign-in': typeof AuthSignInRoute;
  '/auth/sign-out': typeof AuthSignOutRoute;
  '/checkout/cancel': typeof CheckoutCancelRoute;
  '/checkout/success': typeof CheckoutSuccessRoute;
  '/d/$id': typeof DIdRoute;
  '/eric/active': typeof EricActiveRoute;
  '/eric/agent-telemetry': typeof EricAgentTelemetryRoute;
  '/eric/awaiting': typeof EricAwaitingRoute;
  '/eric/capacity': typeof EricCapacityRoute;
  '/eric/clients': typeof EricClientsRoute;
  '/eric/contact': typeof EricContactRoute;
  '/eric/content': typeof EricContentRoute;
  '/eric/input-requests': typeof EricInputRequestsRoute;
  '/eric/notifications': typeof EricNotificationsRoute;
  '/eric/onboarding': typeof EricOnboardingRoute;
  '/eric/os': typeof EricOsRoute;
  '/eric/reports': typeof EricReportsRouteWithChildren;
  '/eric/waitlist': typeof EricWaitlistRoute;
  '/onboarding/$token': typeof OnboardingTokenRouteWithChildren;
  '/portal/booking': typeof PortalBookingRoute;
  '/portal/context': typeof PortalContextRoute;
  '/portal/help': typeof PortalHelpRoute;
  '/portal/notifications': typeof PortalNotificationsRoute;
  '/portal/playbook': typeof PortalPlaybookRoute;
  '/portal/settings': typeof PortalSettingsRoute;
  '/portal/welcome': typeof PortalWelcomeRoute;
  '/eric': typeof EricIndexRoute;
  '/onboarding': typeof OnboardingIndexRoute;
  '/os': typeof OsIndexRoute;
  '/portal': typeof PortalIndexRoute;
  '/eric/reports/$reportId': typeof EricReportsReportIdRoute;
  '/eric/tasks/$taskId': typeof EricTasksTaskIdRouteWithChildren;
  '/onboarding/$token/submitted': typeof OnboardingTokenSubmittedRoute;
  '/portal/tasks/$taskId': typeof PortalTasksTaskIdRoute;
  '/portal/tasks/new': typeof PortalTasksNewRoute;
  '/portal/reports': typeof PortalReportsIndexRoute;
  '/eric/tasks/$taskId/stage': typeof EricTasksTaskIdStageRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/billing': typeof BillingRoute;
  '/eric': typeof EricRouteWithChildren;
  '/os': typeof OsRouteWithChildren;
  '/portal': typeof PortalRouteWithChildren;
  '/auth/callback': typeof AuthCallbackRoute;
  '/auth/sign-in': typeof AuthSignInRoute;
  '/auth/sign-out': typeof AuthSignOutRoute;
  '/checkout/cancel': typeof CheckoutCancelRoute;
  '/checkout/success': typeof CheckoutSuccessRoute;
  '/d/$id': typeof DIdRoute;
  '/eric/active': typeof EricActiveRoute;
  '/eric/agent-telemetry': typeof EricAgentTelemetryRoute;
  '/eric/awaiting': typeof EricAwaitingRoute;
  '/eric/capacity': typeof EricCapacityRoute;
  '/eric/clients': typeof EricClientsRoute;
  '/eric/contact': typeof EricContactRoute;
  '/eric/content': typeof EricContentRoute;
  '/eric/input-requests': typeof EricInputRequestsRoute;
  '/eric/notifications': typeof EricNotificationsRoute;
  '/eric/onboarding': typeof EricOnboardingRoute;
  '/eric/os': typeof EricOsRoute;
  '/eric/reports': typeof EricReportsRouteWithChildren;
  '/eric/waitlist': typeof EricWaitlistRoute;
  '/onboarding/$token': typeof OnboardingTokenRouteWithChildren;
  '/portal/booking': typeof PortalBookingRoute;
  '/portal/context': typeof PortalContextRoute;
  '/portal/help': typeof PortalHelpRoute;
  '/portal/notifications': typeof PortalNotificationsRoute;
  '/portal/playbook': typeof PortalPlaybookRoute;
  '/portal/settings': typeof PortalSettingsRoute;
  '/portal/welcome': typeof PortalWelcomeRoute;
  '/eric/': typeof EricIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/os/': typeof OsIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/eric/reports/$reportId': typeof EricReportsReportIdRoute;
  '/eric/tasks/$taskId': typeof EricTasksTaskIdRouteWithChildren;
  '/onboarding/$token/submitted': typeof OnboardingTokenSubmittedRoute;
  '/portal/tasks/$taskId': typeof PortalTasksTaskIdRoute;
  '/portal/tasks/new': typeof PortalTasksNewRoute;
  '/portal/reports/': typeof PortalReportsIndexRoute;
  '/eric/tasks/$taskId/stage': typeof EricTasksTaskIdStageRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/billing'
    | '/eric'
    | '/os'
    | '/portal'
    | '/auth/callback'
    | '/auth/sign-in'
    | '/auth/sign-out'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/d/$id'
    | '/eric/active'
    | '/eric/agent-telemetry'
    | '/eric/awaiting'
    | '/eric/capacity'
    | '/eric/clients'
    | '/eric/contact'
    | '/eric/content'
    | '/eric/input-requests'
    | '/eric/notifications'
    | '/eric/onboarding'
    | '/eric/os'
    | '/eric/reports'
    | '/eric/waitlist'
    | '/onboarding/$token'
    | '/portal/booking'
    | '/portal/context'
    | '/portal/help'
    | '/portal/notifications'
    | '/portal/playbook'
    | '/portal/settings'
    | '/portal/welcome'
    | '/eric/'
    | '/onboarding/'
    | '/os/'
    | '/portal/'
    | '/eric/reports/$reportId'
    | '/eric/tasks/$taskId'
    | '/onboarding/$token/submitted'
    | '/portal/tasks/$taskId'
    | '/portal/tasks/new'
    | '/portal/reports/'
    | '/eric/tasks/$taskId/stage';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/billing'
    | '/auth/callback'
    | '/auth/sign-in'
    | '/auth/sign-out'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/d/$id'
    | '/eric/active'
    | '/eric/agent-telemetry'
    | '/eric/awaiting'
    | '/eric/capacity'
    | '/eric/clients'
    | '/eric/contact'
    | '/eric/content'
    | '/eric/input-requests'
    | '/eric/notifications'
    | '/eric/onboarding'
    | '/eric/os'
    | '/eric/reports'
    | '/eric/waitlist'
    | '/onboarding/$token'
    | '/portal/booking'
    | '/portal/context'
    | '/portal/help'
    | '/portal/notifications'
    | '/portal/playbook'
    | '/portal/settings'
    | '/portal/welcome'
    | '/eric'
    | '/onboarding'
    | '/os'
    | '/portal'
    | '/eric/reports/$reportId'
    | '/eric/tasks/$taskId'
    | '/onboarding/$token/submitted'
    | '/portal/tasks/$taskId'
    | '/portal/tasks/new'
    | '/portal/reports'
    | '/eric/tasks/$taskId/stage';
  id:
    | '__root__'
    | '/'
    | '/billing'
    | '/eric'
    | '/os'
    | '/portal'
    | '/auth/callback'
    | '/auth/sign-in'
    | '/auth/sign-out'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/d/$id'
    | '/eric/active'
    | '/eric/agent-telemetry'
    | '/eric/awaiting'
    | '/eric/capacity'
    | '/eric/clients'
    | '/eric/contact'
    | '/eric/content'
    | '/eric/input-requests'
    | '/eric/notifications'
    | '/eric/onboarding'
    | '/eric/os'
    | '/eric/reports'
    | '/eric/waitlist'
    | '/onboarding/$token'
    | '/portal/booking'
    | '/portal/context'
    | '/portal/help'
    | '/portal/notifications'
    | '/portal/playbook'
    | '/portal/settings'
    | '/portal/welcome'
    | '/eric/'
    | '/onboarding/'
    | '/os/'
    | '/portal/'
    | '/eric/reports/$reportId'
    | '/eric/tasks/$taskId'
    | '/onboarding/$token/submitted'
    | '/portal/tasks/$taskId'
    | '/portal/tasks/new'
    | '/portal/reports/'
    | '/eric/tasks/$taskId/stage';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  BillingRoute: typeof BillingRoute;
  EricRoute: typeof EricRouteWithChildren;
  OsRoute: typeof OsRouteWithChildren;
  PortalRoute: typeof PortalRouteWithChildren;
  AuthCallbackRoute: typeof AuthCallbackRoute;
  AuthSignInRoute: typeof AuthSignInRoute;
  AuthSignOutRoute: typeof AuthSignOutRoute;
  CheckoutCancelRoute: typeof CheckoutCancelRoute;
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute;
  DIdRoute: typeof DIdRoute;
  OnboardingTokenRoute: typeof OnboardingTokenRouteWithChildren;
  OnboardingIndexRoute: typeof OnboardingIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal';
      path: '/portal';
      fullPath: '/portal';
      preLoaderRoute: typeof PortalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/os': {
      id: '/os';
      path: '/os';
      fullPath: '/os';
      preLoaderRoute: typeof OsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/eric': {
      id: '/eric';
      path: '/eric';
      fullPath: '/eric';
      preLoaderRoute: typeof EricRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/billing': {
      id: '/billing';
      path: '/billing';
      fullPath: '/billing';
      preLoaderRoute: typeof BillingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal/': {
      id: '/portal/';
      path: '/';
      fullPath: '/portal/';
      preLoaderRoute: typeof PortalIndexRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/os/': {
      id: '/os/';
      path: '/';
      fullPath: '/os/';
      preLoaderRoute: typeof OsIndexRouteImport;
      parentRoute: typeof OsRoute;
    };
    '/onboarding/': {
      id: '/onboarding/';
      path: '/onboarding';
      fullPath: '/onboarding/';
      preLoaderRoute: typeof OnboardingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/eric/': {
      id: '/eric/';
      path: '/';
      fullPath: '/eric/';
      preLoaderRoute: typeof EricIndexRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/portal/welcome': {
      id: '/portal/welcome';
      path: '/welcome';
      fullPath: '/portal/welcome';
      preLoaderRoute: typeof PortalWelcomeRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/settings': {
      id: '/portal/settings';
      path: '/settings';
      fullPath: '/portal/settings';
      preLoaderRoute: typeof PortalSettingsRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/playbook': {
      id: '/portal/playbook';
      path: '/playbook';
      fullPath: '/portal/playbook';
      preLoaderRoute: typeof PortalPlaybookRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/notifications': {
      id: '/portal/notifications';
      path: '/notifications';
      fullPath: '/portal/notifications';
      preLoaderRoute: typeof PortalNotificationsRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/help': {
      id: '/portal/help';
      path: '/help';
      fullPath: '/portal/help';
      preLoaderRoute: typeof PortalHelpRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/context': {
      id: '/portal/context';
      path: '/context';
      fullPath: '/portal/context';
      preLoaderRoute: typeof PortalContextRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/booking': {
      id: '/portal/booking';
      path: '/booking';
      fullPath: '/portal/booking';
      preLoaderRoute: typeof PortalBookingRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/onboarding/$token': {
      id: '/onboarding/$token';
      path: '/onboarding/$token';
      fullPath: '/onboarding/$token';
      preLoaderRoute: typeof OnboardingTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/eric/waitlist': {
      id: '/eric/waitlist';
      path: '/waitlist';
      fullPath: '/eric/waitlist';
      preLoaderRoute: typeof EricWaitlistRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/reports': {
      id: '/eric/reports';
      path: '/reports';
      fullPath: '/eric/reports';
      preLoaderRoute: typeof EricReportsRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/os': {
      id: '/eric/os';
      path: '/os';
      fullPath: '/eric/os';
      preLoaderRoute: typeof EricOsRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/onboarding': {
      id: '/eric/onboarding';
      path: '/onboarding';
      fullPath: '/eric/onboarding';
      preLoaderRoute: typeof EricOnboardingRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/notifications': {
      id: '/eric/notifications';
      path: '/notifications';
      fullPath: '/eric/notifications';
      preLoaderRoute: typeof EricNotificationsRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/input-requests': {
      id: '/eric/input-requests';
      path: '/input-requests';
      fullPath: '/eric/input-requests';
      preLoaderRoute: typeof EricInputRequestsRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/content': {
      id: '/eric/content';
      path: '/content';
      fullPath: '/eric/content';
      preLoaderRoute: typeof EricContentRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/contact': {
      id: '/eric/contact';
      path: '/contact';
      fullPath: '/eric/contact';
      preLoaderRoute: typeof EricContactRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/clients': {
      id: '/eric/clients';
      path: '/clients';
      fullPath: '/eric/clients';
      preLoaderRoute: typeof EricClientsRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/capacity': {
      id: '/eric/capacity';
      path: '/capacity';
      fullPath: '/eric/capacity';
      preLoaderRoute: typeof EricCapacityRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/awaiting': {
      id: '/eric/awaiting';
      path: '/awaiting';
      fullPath: '/eric/awaiting';
      preLoaderRoute: typeof EricAwaitingRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/agent-telemetry': {
      id: '/eric/agent-telemetry';
      path: '/agent-telemetry';
      fullPath: '/eric/agent-telemetry';
      preLoaderRoute: typeof EricAgentTelemetryRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/active': {
      id: '/eric/active';
      path: '/active';
      fullPath: '/eric/active';
      preLoaderRoute: typeof EricActiveRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/d/$id': {
      id: '/d/$id';
      path: '/d/$id';
      fullPath: '/d/$id';
      preLoaderRoute: typeof DIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/checkout/success': {
      id: '/checkout/success';
      path: '/checkout/success';
      fullPath: '/checkout/success';
      preLoaderRoute: typeof CheckoutSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/checkout/cancel': {
      id: '/checkout/cancel';
      path: '/checkout/cancel';
      fullPath: '/checkout/cancel';
      preLoaderRoute: typeof CheckoutCancelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth/sign-out': {
      id: '/auth/sign-out';
      path: '/auth/sign-out';
      fullPath: '/auth/sign-out';
      preLoaderRoute: typeof AuthSignOutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth/sign-in': {
      id: '/auth/sign-in';
      path: '/auth/sign-in';
      fullPath: '/auth/sign-in';
      preLoaderRoute: typeof AuthSignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth/callback': {
      id: '/auth/callback';
      path: '/auth/callback';
      fullPath: '/auth/callback';
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal/reports/': {
      id: '/portal/reports/';
      path: '/reports';
      fullPath: '/portal/reports/';
      preLoaderRoute: typeof PortalReportsIndexRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/tasks/new': {
      id: '/portal/tasks/new';
      path: '/tasks/new';
      fullPath: '/portal/tasks/new';
      preLoaderRoute: typeof PortalTasksNewRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/tasks/$taskId': {
      id: '/portal/tasks/$taskId';
      path: '/tasks/$taskId';
      fullPath: '/portal/tasks/$taskId';
      preLoaderRoute: typeof PortalTasksTaskIdRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/onboarding/$token/submitted': {
      id: '/onboarding/$token/submitted';
      path: '/submitted';
      fullPath: '/onboarding/$token/submitted';
      preLoaderRoute: typeof OnboardingTokenSubmittedRouteImport;
      parentRoute: typeof OnboardingTokenRoute;
    };
    '/eric/tasks/$taskId': {
      id: '/eric/tasks/$taskId';
      path: '/tasks/$taskId';
      fullPath: '/eric/tasks/$taskId';
      preLoaderRoute: typeof EricTasksTaskIdRouteImport;
      parentRoute: typeof EricRoute;
    };
    '/eric/reports/$reportId': {
      id: '/eric/reports/$reportId';
      path: '/$reportId';
      fullPath: '/eric/reports/$reportId';
      preLoaderRoute: typeof EricReportsReportIdRouteImport;
      parentRoute: typeof EricReportsRoute;
    };
    '/eric/tasks/$taskId/stage': {
      id: '/eric/tasks/$taskId/stage';
      path: '/stage';
      fullPath: '/eric/tasks/$taskId/stage';
      preLoaderRoute: typeof EricTasksTaskIdStageRouteImport;
      parentRoute: typeof EricTasksTaskIdRoute;
    };
  }
}

interface EricReportsRouteChildren {
  EricReportsReportIdRoute: typeof EricReportsReportIdRoute;
}

const EricReportsRouteChildren: EricReportsRouteChildren = {
  EricReportsReportIdRoute: EricReportsReportIdRoute,
};

const EricReportsRouteWithChildren = EricReportsRoute._addFileChildren(
  EricReportsRouteChildren,
);

interface EricTasksTaskIdRouteChildren {
  EricTasksTaskIdStageRoute: typeof EricTasksTaskIdStageRoute;
}

const EricTasksTaskIdRouteChildren: EricTasksTaskIdRouteChildren = {
  EricTasksTaskIdStageRoute: EricTasksTaskIdStageRoute,
};

const EricTasksTaskIdRouteWithChildren = EricTasksTaskIdRoute._addFileChildren(
  EricTasksTaskIdRouteChildren,
);

interface EricRouteChildren {
  EricActiveRoute: typeof EricActiveRoute;
  EricAgentTelemetryRoute: typeof EricAgentTelemetryRoute;
  EricAwaitingRoute: typeof EricAwaitingRoute;
  EricCapacityRoute: typeof EricCapacityRoute;
  EricClientsRoute: typeof EricClientsRoute;
  EricContactRoute: typeof EricContactRoute;
  EricContentRoute: typeof EricContentRoute;
  EricInputRequestsRoute: typeof EricInputRequestsRoute;
  EricNotificationsRoute: typeof EricNotificationsRoute;
  EricOnboardingRoute: typeof EricOnboardingRoute;
  EricOsRoute: typeof EricOsRoute;
  EricReportsRoute: typeof EricReportsRouteWithChildren;
  EricWaitlistRoute: typeof EricWaitlistRoute;
  EricIndexRoute: typeof EricIndexRoute;
  EricTasksTaskIdRoute: typeof EricTasksTaskIdRouteWithChildren;
}

const EricRouteChildren: EricRouteChildren = {
  EricActiveRoute: EricActiveRoute,
  EricAgentTelemetryRoute: EricAgentTelemetryRoute,
  EricAwaitingRoute: EricAwaitingRoute,
  EricCapacityRoute: EricCapacityRoute,
  EricClientsRoute: EricClientsRoute,
  EricContactRoute: EricContactRoute,
  EricContentRoute: EricContentRoute,
  EricInputRequestsRoute: EricInputRequestsRoute,
  EricNotificationsRoute: EricNotificationsRoute,
  EricOnboardingRoute: EricOnboardingRoute,
  EricOsRoute: EricOsRoute,
  EricReportsRoute: EricReportsRouteWithChildren,
  EricWaitlistRoute: EricWaitlistRoute,
  EricIndexRoute: EricIndexRoute,
  EricTasksTaskIdRoute: EricTasksTaskIdRouteWithChildren,
};

const EricRouteWithChildren = EricRoute._addFileChildren(EricRouteChildren);

interface OsRouteChildren {
  OsIndexRoute: typeof OsIndexRoute;
}

const OsRouteChildren: OsRouteChildren = {
  OsIndexRoute: OsIndexRoute,
};

const OsRouteWithChildren = OsRoute._addFileChildren(OsRouteChildren);

interface PortalRouteChildren {
  PortalBookingRoute: typeof PortalBookingRoute;
  PortalContextRoute: typeof PortalContextRoute;
  PortalHelpRoute: typeof PortalHelpRoute;
  PortalNotificationsRoute: typeof PortalNotificationsRoute;
  PortalPlaybookRoute: typeof PortalPlaybookRoute;
  PortalSettingsRoute: typeof PortalSettingsRoute;
  PortalWelcomeRoute: typeof PortalWelcomeRoute;
  PortalIndexRoute: typeof PortalIndexRoute;
  PortalTasksTaskIdRoute: typeof PortalTasksTaskIdRoute;
  PortalTasksNewRoute: typeof PortalTasksNewRoute;
  PortalReportsIndexRoute: typeof PortalReportsIndexRoute;
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalBookingRoute: PortalBookingRoute,
  PortalContextRoute: PortalContextRoute,
  PortalHelpRoute: PortalHelpRoute,
  PortalNotificationsRoute: PortalNotificationsRoute,
  PortalPlaybookRoute: PortalPlaybookRoute,
  PortalSettingsRoute: PortalSettingsRoute,
  PortalWelcomeRoute: PortalWelcomeRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalTasksTaskIdRoute: PortalTasksTaskIdRoute,
  PortalTasksNewRoute: PortalTasksNewRoute,
  PortalReportsIndexRoute: PortalReportsIndexRoute,
};

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren);

interface OnboardingTokenRouteChildren {
  OnboardingTokenSubmittedRoute: typeof OnboardingTokenSubmittedRoute;
}

const OnboardingTokenRouteChildren: OnboardingTokenRouteChildren = {
  OnboardingTokenSubmittedRoute: OnboardingTokenSubmittedRoute,
};

const OnboardingTokenRouteWithChildren = OnboardingTokenRoute._addFileChildren(
  OnboardingTokenRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillingRoute: BillingRoute,
  EricRoute: EricRouteWithChildren,
  OsRoute: OsRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignOutRoute: AuthSignOutRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  DIdRoute: DIdRoute,
  OnboardingTokenRoute: OnboardingTokenRouteWithChildren,
  OnboardingIndexRoute: OnboardingIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
